<header class="app-header" role="banner">
  <div class="app-header__inner">
    <div class="app-header__logo">
      <img src="/assets/images/dci-logo.svg" alt="DCI Marketing" width="119" height="45" />
    </div>
    <div class="app-header__actions">
      <div class="app-header__search-wrapper" (focusout)="onWrapperFocusOut($event)">
        <div class="app-header__search">
          <mat-icon class="app-header__search-icon" aria-hidden="true">search</mat-icon>
          <input
            #searchInput
            type="search"
            class="app-header__search-input"
            name="header-search"
            placeholder="Search"
            autocomplete="off"
            role="combobox"
            aria-autocomplete="list"
            aria-haspopup="listbox"
            [attr.aria-expanded]="showResults()"
            aria-controls="search-results-listbox"
            [attr.aria-activedescendant]="activeIndex() >= 0 ? 'search-result-' + activeIndex() : null"
            [(ngModel)]="searchText"
            (ngModelChange)="onSearchInput()"
            (keydown)="onKeydown($event)"
            (focus)="results().length && showResults.set(true)"
            aria-label="Search vehicles"
          />
        </div>
        @if (showResults()) {
          <div class="search-results"
               id="search-results-listbox"
               role="listbox"
               aria-label="Search results">
            @if (isSearching()) {
              <div class="search-results__status" role="status">Searching...</div>
            } @else if (!results().length) {
              <div class="search-results__status" role="status">No results found</div>
            } @else {
              @for (vehicle of results(); track vehicle.id; let i = $index) {
                <div class="search-results__item"
                     [id]="'search-result-' + i"
                     role="option"
                     [attr.aria-selected]="activeIndex() === i"
                     [class.active]="activeIndex() === i"
                     (mousedown)="onResultMouseDown($event, vehicle)"
                     (pointerenter)="activeIndex.set(i)">
                  <span class="search-results__name">{{vehicle.vehicleYear}} {{vehicle.vehicleName}}</span>
                  <span class="search-results__meta">{{vehicle.regionName}} · {{vehicle.divisionName}}</span>
                </div>
              }
            }
          </div>
        }
        <span class="sr-only" aria-live="polite">{{ liveAnnouncement() }}</span>
      </div>
      <app-user-profile class="app-header__user"></app-user-profile>
    </div>
  </div>
</header>
